import yup from 'schemas/validation/feature'

import { releaseNumberRegex } from 'utils/validation'
import strings from 'utils/strings'

import { INTERNAL } from 'constants/featureTypes'

import { isInternal } from './utils'

const featureMetaSchema = yup.object().shape({
  status: yup.string(),
  description: yup.string().required().unique().max(80),
  successorCode: yup.string().when('type', {
    is: isInternal,
    then: yup.string().optionalLength(7, strings.must_be_6_chars_validation),
  }),
  type: yup.string(),
  priority: yup.number().when('type', {
    is: isInternal,
    then: yup.number().required().max(100).min(0),
  }),
  subGroup: yup
    .string()
    .when('type', {
      is: INTERNAL,
      then: yup.string().required(),
    }) // TODO: find way to combine these two 'when' functions
    .when('$type', (type, schema) =>
      type === INTERNAL ? yup.string().required() : schema
    ),
  releaseNumber: yup.string().when('type', {
    is: isInternal,
    then: yup
      .string()
      .required()
      .length(9)
      .matches(releaseNumberRegex, strings.ers_release_format_required),
  }),
})

export default featureMetaSchema
